import React from 'react';
import cx from 'classnames';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {FormViewEnum} from '../../../../stores/Form/Form';
import {texts} from '../AdvancedSearch/AdvancedSearchDrawer/texts';
import styles from './style.module.scss';
import {ModernTooltip} from '../../../../components/Common/Tooltip/ModernTooltip';

type Props = {
    onViewChange: (viewType: FormViewEnum) => void;
    activeView: FormViewEnum;
    componentClasses?: string;
    isDisabled?: boolean;
};

const views = {
    table: PriorityIcon.tableView,
    form: PriorityIcon.recordView
};

export const FormViewToggler = ({
    onViewChange,
    activeView,
    componentClasses,
    isDisabled
}: Props) => {
    return (
        <ModernTooltip tooltip={texts.changeViewTooltip} position="bottom">
            <div
                className={cx(styles.gridViewToggler, componentClasses, {
                    [styles.disabled]: isDisabled
                })}
            >
                {Object.keys(views).map((view: string) => {
                    return (
                        <div
                            key={view}
                            className={cx(styles.btn, {[styles.active]: activeView === view})}
                        >
                            <Icon
                                onClick={() => onViewChange(view as FormViewEnum)}
                                icon={views[view]}
                            />
                        </div>
                    );
                })}
            </div>
        </ModernTooltip>
    );
};
